<script>
  export let src = "meloni";
  export let sentiment = "positive";
  export let title = '';
  export let subtitle = '';

  const stickers = [
    '/img/sticker-1.webp',
    '/img/sticker-2.webp',
    '/img/sticker-3.webp',
  ];

  const images = {
    meloni: {
      positive: {
        src: '/img/meloni-positive.webp',
        color: 'var(--positive)',
      },
      negative: {
        src: '/img/meloni-negative.webp',
        color: 'var(--negative)',
      },
      neutral: {
        src: '/img/meloni-neutral.webp',
        color: 'var(--neutral)',
      },
      clean: {
        src: '/img/meloni-clean.webp',
        color: 'var(--clean)',
      },
      meloni: {
        src: '/img/meloni-clean.webp',
        color: 'var(--meloni)',
      }
    },
    schlein: {
      positive: {
        src: '/img/schlein-positive.webp',
        color: 'var(--positive)',
      },
      negative: {
        src: '/img/schlein-negative.webp',
        color: 'var(--negative)',
      },
      neutral: {
        src: '/img/schlein-neutral.webp',
        color: 'var(--neutral)',
      },
      clean: {
        src: '/img/schlein-clean.webp',
        color: 'var(--clean)',
      },
      schlein: {
        src: '/img/schlein-clean.webp',
        color: 'var(--schlein)',
      }
    },
  };

  const image = `background-image: url(${images[src][sentiment].src})`;
  const sticker = `background-image: url(${stickers[Math.floor(Math.random()*stickers.length)]})`;
  const background = `background-color: ${images[src][sentiment].color}`;
  const color = `color: ${images[src][sentiment].color}`;
</script>

<div class="icon icon-image">
  <div class="icon--mask">
    <div class="icon--image" style={image} />
    <div class="icon--color" style={background} />
    <div class="icon--sticker" style={sticker} />
    {#if title || subtitle}
    <header>
      {#if title}<h2 style={color}>{title}</h2>{/if}
      {#if subtitle}<h3>{subtitle}</h3>{/if}
    </header>
    {/if}
  </div>
</div>

<style>
.icon.icon-image {
  display: block;
  height: 100%;
  position: relative;
  width: 100%;
}

.icon--image,
.icon--color,
.icon--sticker,
.icon--mask {
  bottom: 0;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}

.icon--mask {
  border-radius: 50%;
  box-shadow: 1px 1px 2px 1px var(--shadow), -1px -1px 1px 1px var(--shadow);
  overflow: hidden;
}

.icon--sticker {
  background-size: cover;
  mix-blend-mode: multiply;
  z-index: 3;
}

.icon--image {
  background-size: cover;
  z-index: 2;
}

.icon--color {
  z-index: 1;
}

header {
    background: transparent;
    display: block;
    left: 50%;
    position: absolute;
    bottom: 10%;
    transform-origin: center center;
    transform: translate3d(-50%, 0, 0) rotate(-5deg);
    z-index: 4;
  }

  header h2,
  header h3 {
    background: var(--light);
    box-shadow: 0 0 0 2px var(--light);
    line-height: 1;
    margin: 0;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;
  }

  header h3 {
    font-size: 12px;
  }
</style>